import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    container: {
        paddingHorizontal: 25,
        marginTop: 20
    },
    title: {
        textAlign: 'center',
        fontSize: 16,
        fontWeight: 'bold',
        marginTop: 5
    },
    contentImgsCoins: {
        flexDirection: 'row',
        justifyContent: 'space-around',
        marginTop: 28
    },
    imgCoins: {
        width: 50,
        height: 50
    },
    contentPrice: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingHorizontal: 25,
        marginTop: 10
    },
    textPriceLeft: {
        fontSize: 16
    },
    textPriceRight: {
        fontSize: 16,
        textAlign: 'right'
    },
    price: {
        fontSize: 16,
        fontWeight: 'bold'
    },
    hr: {
        height: 1,
        marginTop: 18,
        backgroundColor: "#2C2C2E",
        opacity: 0.5,
    },
    contentCheckbox: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        width: '90%',
        marginTop: 10
    }
});

export default styles;
